import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialogHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 24px',
}));
